import hotelEvents from '../config/hotel-events';

export default function HotelsFiltersController(
    $scope,
    $rootScope,
    $window,
    $stateParams,
    $timeout,
    hotelsFactory,
    filterDetector,
    hotelResultService,
    hotelSearchResults
) {
    'ngInject';

            const vm = this;
            Object.assign(vm, {
                $onInit,

                submitHotelNameField,
                clearHotelNameField,
                isHotelNameClearIconVisible,
                onBlurHotelNameField,
                toggleHotelNameHoveredState,
            });

            let defaultFilters;
            let defaultPriceFilter;
            let filters;
            let previousHotelNameValue;
            const formData = hotelsFactory.getFormData();
            const INITIAL_SEARCH_RADIUS = 0;
            const defaultCoordinates = {
                latitude: formData.latitude,
                longitude: formData.longitude,
            };

            function $onInit() {
                vm.hotelNameFilterForm = {
                    text: '',
                };

                subscribe();
                processFilters(hotelSearchResults);

                watch();
            }

            $scope.showFilters = true;
            $scope.typeaheadHelpers = {
                addressQuery: '',
            };
            $scope.clearFilters = clearFilters;
            $scope.clearSearchForm = clearSearchForm;
            $scope.toggleLocation = toggleLocation;
            $scope.toggleStars = toggleStars;
            $scope.toggleHotelName = toggleHotelName;
            $scope.toggleAmenities = toggleAmenities;
            $scope.toggleRefundable = toggleRefundable;
            $scope.updatedFilters = {};

            function toggleHotelNameHoveredState(isActive) {
                vm.hotelNameFocused = isActive;
            }

            function subscribe() {
                $scope.$on(hotelEvents.HOTELS_CLICK_HOTEL_MARKER, function(scope, marker) {
                    $scope.updateFilters.HotelName = marker.name;
                });

                $scope.$on(hotelEvents.HOTELS_CLEAR_HOTEL_FILTERS, clearFilters);
                $scope.$on(hotelEvents.HOTELS_TRIGGER_HOTEL_FILTERS, () => $scope.showFilters = !$scope.showFilters);
            }

            function watch() {
                $scope.$watch('filters.poi', function(newValue, oldValue) {
                    if (newValue !== oldValue && !newValue) {
                        $scope.updateFilters.latitude = defaultCoordinates.latitude;
                        $scope.updateFilters.longitude = defaultCoordinates.longitude;
                    }
                });

                $timeout(() => $scope.$watch('updateFilters', onFiltersChange, true), 0);
            }

            function applyFilters(filter) {
                $rootScope.$broadcast(hotelEvents.HOTELS_APPLY_FILTERS, filter);
            }

            function hasNameFailValidation() {
                if (vm.hotelNameFilterForm.$invalid) {
                    return true;
                }

                if (angular.isDefined(vm.hotelNameFilterForm.text) && !vm.hotelNameFilterForm.text.length && !vm.hotelNameFilterForm.$submitted) {
                    return true;
                }
                return previousHotelNameValue === vm.hotelNameFilterForm.text;
            }
            function onBlurHotelNameField() {
                if (vm.hotelNameFocused) {
                    return;
                }
                vm.submitHotelNameField();
            }

            function submitHotelNameField($item) {
                if (hasNameFailValidation()) {
                    return;
                }
                previousHotelNameValue = vm.hotelNameFilterForm.text;

                const hotelName = $item
                    ? $item
                    : vm.hotelNameFilterForm.text;

                const chosenFilters = {hotelName};

                if ($scope.updateFilters) {
                    delete $scope.updateFilters.hotelName;
                    Object.assign(chosenFilters, $scope.updateFilters);
                }

                applyFilters(chosenFilters);
            }

            function isHotelNameClearIconVisible() {
                return !!(previousHotelNameValue
                    && previousHotelNameValue.length
                    && vm.hotelNameFilterForm.text
                    && vm.hotelNameFilterForm.text.length);
            }

            function clearHotelNameField() {
                previousHotelNameValue = '';
                vm.hotelNameFilterForm.text = '';
                const query = {hotelName: ''};
                $scope.updateFilters.hotelName = '';
                applyFilters(query);
            }

            function processFilters(result) {
                filters = result.Filters;
                vm.filtersAvailable = !_.isEmpty(filters);
                if (!vm.filtersAvailable) {
                    return;
                }
                $scope.filters = result.Filters;

                $scope.updateFilters = {
                    SearchId: formData.SearchId,
                    StarRatingFilter: [],
                    MaximumRadiusSelected: angular.copy(filters.MaximumRadius[filters.MaximumRadius.length - 1]),
                    latitude: formData.latitude,
                    longitude: formData.longitude,
                };

                if (+$stateParams.Radius !== INITIAL_SEARCH_RADIUS) {
                    hotelResultService.prepareFiltersModel($scope.updateFilters, $stateParams);
                    prepareHotelNameModel();
                }

                $scope.priceRangeSlider = {
                    model: filters.MinimumTotalPrice,
                    range: filters.MaximumTotalPrice,
                    floor: filters.MinimumTotalPrice,
                    ceiling: filters.MaximumTotalPrice,
                };

                defaultPriceFilter = angular.copy($scope.priceRangeSlider);
                defaultFilters = angular.copy($scope.updateFilters);
            }

            function clearFilters() {
                $scope.priceRangeSlider = angular.extend($scope.priceRangeSlider, defaultPriceFilter);
                $scope.updateFilters = angular.extend(angular.copy(defaultFilters),
                    {
                        MainAmenityFilter: [],
                        PaymentTypeFilter: [],
                        RefundableFilter: [],
                        MaximumTotalPriceFilter: defaultPriceFilter.ceiling,
                        MinimumTotalPriceFilter: defaultPriceFilter.floor,
                    });
            }

            function onFiltersChange(newValue, oldValue) {
                if (newValue === oldValue || hotelNameHasNotChanged()) {
                    return;
                }

                $window.scrollTo(0, 0);

                const chosenFilters = newValue;

                if (vm.hotelNameFilterForm && vm.hotelNameFilterForm.text) {
                   Object.assign(chosenFilters, {hotelName: vm.hotelNameFilterForm.text});
                }

                $rootScope.$broadcast(hotelEvents.HOTELS_APPLY_FILTERS, chosenFilters);

                function hotelNameHasNotChanged() {
                    return oldValue.HotelName === null && angular.isUndefined(newValue.HotelName)
                        || oldValue.HotelName && angular.isUndefined(newValue.HotelName);
                }
            }

            function clearSearchForm() {
                $scope.filters.poi = '';
            }

            function toggleLocation() {
                $scope.showLocation = !$scope.showLocation;
            }

            function toggleStars() {
                $scope.showStars = !$scope.showStars;
            }

            function toggleHotelName() {
                $scope.showHotel = !$scope.showHotel;
            }

            function toggleAmenities() {
                $scope.showAmenities = !$scope.showAmenities;
            }

            function toggleRefundable() {
                $scope.showRefundable = !$scope.showRefundable;
            }

            const sizeHandler = function(status) {
                if (status) {
                    expandFilterGroup();
                } else {
                    collapseFilterGroup();
                }
            };

            function collapseFilterGroup() {
                $scope.showPrice = false;
                $scope.showLocation = false;
                $scope.showStars = false;
                $scope.showHotel = false;
                $scope.showAmenities = false;
                $scope.showRefundable = false;
            }

            function expandFilterGroup() {
                $scope.showPrice = true;
                $scope.showLocation = true;
                $scope.showStars = true;
                $scope.showHotel = true;
                $scope.showAmenities = true;
                $scope.showRefundable = true;
            }

            function prepareHotelNameModel() {
                $timeout(() => {
                    if ($stateParams.hotelName) {
                        vm.hotelNameFilterForm.text = previousHotelNameValue = $stateParams.hotelName;
                        vm.hotelNameFilterForm.$submitted = true;
                    }
                });
            }

            filterDetector.getWindowWidth(sizeHandler);
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotelFiltersController.js